export class ChatMessage {
    content: string;
    dateTime: string;
    appCode: string;
    keyPrefix: string = 'chat';
    waitResponse: string = '0';
    userName: string;
    userId: string;
    loginId: string;
    domainId: string;
}


export class LearnMessage {
    learningType: string;
    titleContent: string;
    contentType: string;
    mainContent1: string;
    mainContent2: string;
    targetFile: string;
    
     userName: string;
    userId: string;
    loginId: string;
     domainId: string;
     dateTime: string;

     waitResponse: string = '0';
}